import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverContent = /*#__PURE__*/React.forwardRef(({
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}, ref) => /*#__PURE__*/_jsx(PopoverPrimitive.Portal, {
  children: /*#__PURE__*/_jsx(PopoverPrimitive.Content, {
    ref: ref,
    align: align,
    sideOffset: sideOffset,
    className: cn('z-[50000] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-50', className),
    ...props
  })
}));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverContent };